import { Asterisk } from "lucide-react";

const ITEMS = [
  "Derecho a entender",
  "Lectura fácil · UNE 153101",
  "Accesibilidad cognitiva",
  "CAI de Pando · Langreo",
  "Pola de Siero · Asturias",
  "Validado por personas",
];

export default function Marquee() {
  return (
    <div className="relative py-6" data-testid="marquee">
      <div className="marquee border-y-2 border-[var(--ink)] bg-[var(--yellow)] w-[104%] -ml-[2%] -rotate-1 py-3.5">
        <div className="marquee-track">
          {[0, 1].map((half) => (
            <div key={half} className="flex items-center shrink-0" aria-hidden={half === 1}>
              {ITEMS.map((t) => (
                <span
                  key={t + half}
                  className="flex items-center gap-6 px-6 font-display font-bold uppercase tracking-wide text-lg md:text-xl whitespace-nowrap text-[var(--ink)]"
                >
                  {t}
                  <Asterisk className="w-5 h-5 shrink-0" aria-hidden="true" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
